"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3338],{

/***/ 61326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ UserSignIn; },
/* harmony export */   "Cm": function() { return /* binding */ SubscribeToNewsletter; },
/* harmony export */   "GZ": function() { return /* binding */ LandlordSignUp; },
/* harmony export */   "Nd": function() { return /* binding */ GetLandlord; },
/* harmony export */   "Wc": function() { return /* binding */ VerifyCode; },
/* harmony export */   "Wu": function() { return /* binding */ RemoveListing; },
/* harmony export */   "c_": function() { return /* binding */ GetBooker; },
/* harmony export */   "hx": function() { return /* binding */ OauthSignIn; },
/* harmony export */   "ii": function() { return /* binding */ BookerSignUp; },
/* harmony export */   "qL": function() { return /* binding */ SaveListing; },
/* harmony export */   "qd": function() { return /* binding */ AdminSignIn; },
/* harmony export */   "yp": function() { return /* binding */ SendVerificationCode; }
/* harmony export */ });
/* harmony import */ var _hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93551);

function OauthSignIn(params) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/oauth", "post", {
        data: params
    });
}
function UserSignIn(params) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/signin", "post", {
        data: params
    });
}
function AdminSignIn(params) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/admins/signin", "post", {
        data: params
    });
}
function LandlordSignUp(params) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/landlord", "post", {
        data: params
    });
}
function BookerSignUp(params) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/booker", "post", {
        data: params
    });
}
function SendVerificationCode() {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/send-verification", "get");
}
function VerifyCode(data) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/verify-code", "post", {
        data
    });
}
function SubscribeToNewsletter(data) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/subscribe-newsletter", "post", {
        data
    });
}
function GetLandlord() {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/landlord", "get");
}
function GetBooker() {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/booker", "get");
}
function SaveListing(data) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/save-listing", "post", {
        data
    });
}
function RemoveListing(data) {
    return (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_0__/* .request */ .WY)("users/remove-listing", "put", {
        data
    });
}


/***/ }),

/***/ 68989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LogoDarkFull = (props)=>//prettier-ignore
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        ...props,
        viewBox: "0 0 155 51",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_2931_4)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.0219 34.8036H26.037V28.7885H32.0802V40.8468H20.0219V34.8036Z",
                        fill: "#DCDCDC"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.0432 28.7886V34.8037H12.0583V40.8469H0V28.7886H6.0432Z",
                        fill: "url(#paint0_linear_2931_4)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.0583 16.1964H6.04321V22.2115H0V10.1533H12.0583V16.1964Z",
                        fill: "#DCDCDC"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M26.037 22.2116V16.1965H20.0219V10.1533H32.0802V22.2116H26.037Z",
                        fill: "url(#paint1_linear_2931_4)"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M44.9442 31.0001H43.2162V19.5601H45.5362L48.8322 28.5521H48.8642L52.1762 19.5601H54.4962V31.0001H52.7682V22.1201H52.7362L49.5842 31.0001H48.1282L44.9762 22.1201H44.9442V31.0001ZM57.1337 33.8641C56.7817 33.8641 56.5417 33.8321 56.1257 33.7521V32.4721C56.3977 32.5041 56.5417 32.5201 56.7977 32.5201C57.4217 32.5201 58.1577 32.2001 58.4777 30.9201L55.1817 22.8401H56.8937L59.2777 29.0801H59.3097L61.5497 22.8401H63.1977L59.9657 31.1921C59.1817 33.2081 58.3977 33.8641 57.1337 33.8641ZM69.0552 31.0001H63.9512V19.5601H68.7672C71.1192 19.5601 72.4952 20.6161 72.4952 22.4401C72.4952 23.8481 71.6632 24.5041 70.7192 24.8241V24.8561C71.9192 25.0641 72.9432 25.9441 72.9432 27.6561C72.9432 29.8481 71.4232 31.0001 69.0552 31.0001ZM65.7112 24.3121H68.7192C70.1592 24.3121 70.6552 23.7201 70.6552 22.6961C70.6552 21.6881 70.0472 21.0801 68.8472 21.0801H65.7112V24.3121ZM65.7112 29.4801H68.9272C70.6232 29.4801 71.1032 28.6641 71.1032 27.5921C71.1032 26.3921 70.3672 25.7041 69.1672 25.7041H65.7112V29.4801ZM75.5213 31.0001H73.9533V19.5601H75.5213V31.0001ZM79.2175 31.2241C77.5855 31.2241 76.5455 30.2801 76.5455 28.8881C76.5455 27.0641 77.9215 26.5201 79.9535 26.1361C81.2335 25.8961 82.0175 25.7361 82.0175 24.9361C82.0175 24.3441 81.6655 23.8481 80.4655 23.8481C79.0415 23.8481 78.6095 24.2961 78.5295 25.3841H76.9295C77.0095 23.8161 78.0335 22.5841 80.5295 22.5841C82.2095 22.5841 83.5535 23.2881 83.5535 25.4001V29.1441C83.5535 29.7361 83.6335 30.0401 83.9375 30.0401C83.9855 30.0401 84.0335 30.0401 84.1295 30.0241V30.9841C83.8575 31.0481 83.5855 31.0801 83.3295 31.0801C82.5455 31.0801 82.1295 30.7761 82.0335 29.8481H82.0015C81.4735 30.6961 80.5455 31.2241 79.2175 31.2241ZM79.5695 29.9601C80.9775 29.9601 82.0175 29.2401 82.0175 27.8161V26.6481C81.7615 26.8881 81.0575 27.0641 80.2255 27.2401C78.7855 27.5281 78.1775 27.9281 78.1775 28.7761C78.1775 29.5441 78.5935 29.9601 79.5695 29.9601ZM89.4295 22.6001C90.9335 22.6001 92.1495 23.4641 92.1495 25.3361V31.0001H90.5815V25.7681C90.5815 24.6801 90.1015 23.9441 88.9175 23.9441C87.5735 23.9441 86.7095 24.7601 86.7095 25.9921V31.0001H85.1415V22.8401H86.7095V23.8641H86.7415C87.1735 23.2401 88.0215 22.6001 89.4295 22.6001ZM100.805 31.0001H98.9486L96.2766 26.8241L95.0926 27.9601V31.0001H93.5246V19.5601H95.0926V26.2961L98.6606 22.8401H100.469L97.3326 25.8321L100.805 31.0001Z",
                        fill: "#111111"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M106.809 20.6471C108.135 20.6641 109.206 20.8851 109.784 21.0721C109.461 22.2621 109.155 23.3841 108.866 24.7441H108.526C108.322 22.1601 107.54 21.2081 105.993 21.2081C105.058 21.2081 104.497 21.7861 104.497 22.5001C104.497 24.6081 108.985 25.0671 108.985 27.7191C108.985 29.3511 106.911 31.1871 104.293 31.1871C102.661 31.1871 101.42 30.8471 100.842 30.4901C101.182 29.1641 101.505 27.7871 101.743 26.4781H102.083C101.845 29.3511 103.868 30.3201 105.602 30.3201C106.775 30.3201 107.234 29.8611 107.234 29.2151C107.234 27.4131 102.576 26.7331 102.576 24.1831C102.576 22.3471 104.429 20.6471 106.809 20.6471ZM112.758 30.7451C114.611 30.7451 115.801 26.4951 115.801 24.9311C115.801 24.3871 115.614 24.1831 115.308 24.1831C114.628 24.1831 113.387 25.9171 111.925 30.5411C112.197 30.6601 112.469 30.7451 112.758 30.7451ZM110.99 33.8391H108.457C109.426 31.2381 111.109 25.8321 111.109 24.5741C111.109 24.3531 111.024 24.2171 110.871 24.2171C110.65 24.2171 110.344 24.5061 109.902 25.1351L109.715 24.8631C110.548 23.5541 111.466 22.4151 112.452 22.4151C112.996 22.4151 113.353 22.8741 113.353 23.8091C113.353 24.8631 112.673 27.2261 112.248 28.7561L112.333 28.7901C113.88 24.2851 115.427 22.4151 116.668 22.4151C117.552 22.4151 118.147 23.1291 118.147 24.3531C118.147 27.7701 116.141 31.1701 112.911 31.1701C112.503 31.1701 112.112 31.0851 111.789 31.0001C111.534 31.8501 111.262 32.8021 110.99 33.8391ZM125.071 28.9601C125.071 29.2151 125.156 29.3681 125.309 29.3681C125.547 29.3681 125.853 29.0621 126.295 28.4501L126.482 28.7221C125.632 30.0141 124.714 31.1701 123.728 31.1701C123.15 31.1701 122.776 30.7451 122.776 29.8611C122.776 28.7561 123.371 26.3761 123.796 24.7781L123.694 24.7441C122.011 29.3851 120.719 31.1871 119.648 31.1871C118.849 31.1871 117.999 30.4561 117.999 28.9941C117.999 25.9001 120.872 22.0411 126.618 22.5171C125.972 24.5741 125.071 27.8551 125.071 28.9601ZM120.821 29.4361C121.467 29.4361 122.266 28.2631 124.153 22.9591C121.705 23.5881 120.328 26.4611 120.328 28.4671C120.328 29.1301 120.532 29.4361 120.821 29.4361ZM133.428 25.7131H133.326C132.493 23.8431 131.881 22.8571 131.286 22.8571C130.283 22.8571 129.229 25.3391 129.229 27.3961C129.229 28.6881 129.841 29.4361 130.708 29.4361C131.558 29.4361 132.306 28.9431 133.02 27.6171L133.258 27.7701C132.476 29.5551 131.201 31.1701 129.484 31.1701C128.107 31.1701 126.781 30.0481 126.781 28.1441C126.781 25.3221 128.787 22.4151 132.017 22.4151C133.445 22.4151 134.006 23.1801 134.006 24.0301C134.006 24.6591 133.734 25.1861 133.428 25.7131ZM138.569 22.8571C137.719 22.8571 136.852 24.3871 136.529 26.0531C138.365 25.4751 139.368 24.5571 139.368 23.8431C139.368 23.3331 139.028 22.8571 138.569 22.8571ZM141.238 23.8261C141.238 24.9991 139.589 25.8151 136.495 26.2231C136.427 26.5971 136.393 26.9711 136.393 27.3451C136.393 28.8581 137.107 29.4361 137.94 29.4361C138.705 29.4361 139.589 28.8581 140.337 27.6171L140.592 27.7701C139.827 29.5551 138.433 31.1701 136.665 31.1701C135.254 31.1701 133.945 30.0481 133.945 28.1441C133.945 25.2541 135.934 22.4151 139.368 22.4151C140.558 22.4151 141.238 23.0781 141.238 23.8261Z",
                        fill: "#111111"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        opacity: "0.5",
                        d: "M150.543 19.2283C148.049 19.2283 146.08 17.2971 146.08 14.6908C146.08 12.0846 148.049 10.1533 150.543 10.1533C153.036 10.1533 155.005 12.0846 155.005 14.6908C155.005 17.2971 153.036 19.2283 150.543 19.2283ZM150.543 18.4596C152.605 18.4596 154.124 16.8846 154.124 14.6908C154.124 12.4971 152.605 10.9221 150.543 10.9221C148.48 10.9221 146.961 12.4971 146.961 14.6908C146.961 16.8846 148.48 18.4596 150.543 18.4596ZM149.905 17.1658H148.668V12.1783H150.749C151.911 12.1783 152.53 12.7033 152.53 13.6408C152.53 14.3346 152.118 14.7471 151.48 14.8971V14.9158C152.755 15.1221 152.343 17.0158 152.643 17.1096V17.1658H151.368C151.124 16.9408 151.536 15.4033 150.374 15.4033H149.905V17.1658ZM149.905 14.4096H150.411C150.918 14.4096 151.349 14.2971 151.349 13.7533C151.349 13.2096 150.918 13.1158 150.411 13.1158H149.905V14.4096Z",
                        fill: "#111111"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_2931_4",
                        x1: "16.0401",
                        y1: "10.1533",
                        x2: "16.0401",
                        y2: "40.8469",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#2EB39B"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#238A78"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_2931_4",
                        x1: "16.0401",
                        y1: "10.1533",
                        x2: "16.0401",
                        y2: "40.8469",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#2EB39B"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#238A78"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_2931_4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "155",
                            height: "51",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
/* harmony default export */ __webpack_exports__["Z"] = (LogoDarkFull);


/***/ }),

/***/ 64043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports NavEdge, Links, MobileNav */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_logo_dark_full__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68989);
/* harmony import */ var _ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67896);
/* harmony import */ var _src_lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15939);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39483);
"use client";







 // Import NextAuth hook

// Define linkData outside of components so it's accessible
const linkData = [
    {
        title: "HOW IT WORKS ↗",
        link: "#"
    },
    {
        title: "LOCATION PROFILES ↗",
        link: "/location-profile"
    },
    {
        title: "MAGAZINE ↗",
        link: ""
    }
];
const Nav = (param)=>{
    let { howItWorksRef  } = param;
    const [showMobileNav, setShowMobileNav] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { data: session , status  } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_7__.useSession)() // Get session data and status
    ;
    // Check if the user is authenticated
    const isAuthenticated = status === "authenticated";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full h-[80px] flex bg-transparent relative z-10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavEdge, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 bg-white h-[65px] flex justify-between items-center px-5 lg:px-6.25 relative shadow-sm z-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                        href: "/",
                        className: "w-[150px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_logo_dark_full__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: "h-[40px] md:h-[45px]"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Links, {
                        className: "hidden lg:block",
                        howItWorksRef: howItWorksRef
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-[150px] justify-end flex gap-2.5 items-center",
                        children: [
                            isAuthenticated ? // Show Dashboard button when authenticated
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                className: "flex items-center gap-2 mr-4 rounded-full primary-gradient h-7.5 px-2.5 md:h-10",
                                onClick: ()=>next_router__WEBPACK_IMPORTED_MODULE_5___default().push("/dashboard"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        className: "w-4 h-4"
                                    }),
                                    "DASHBOARD"
                                ]
                            }) : // Show Login and Sign Up buttons when not authenticated
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        className: "p-1.25 md:p-2.5 rounded-full",
                                        variant: "ghost",
                                        onClick: ()=>next_router__WEBPACK_IMPORTED_MODULE_5___default().push("/auth/signin"),
                                        children: "LOGIN"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                        className: "rounded-full primary-gradient h-7.5 px-2.5 md:h-10",
                                        onClick: ()=>next_router__WEBPACK_IMPORTED_MODULE_5___default().push("/auth/signup"),
                                        children: "SIGN UP"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: ()=>setShowMobileNav(!showMobileNav),
                                className: "lg:hidden block",
                                children: !showMobileNav ? //prettier-ignore
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    width: "25",
                                    height: "6",
                                    viewBox: "0 0 26 6",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M0.358398 0.535645H25.3584",
                                            stroke: "black"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M0.358398 5.41321H25.3584",
                                            stroke: "black"
                                        })
                                    ]
                                }) : //prettier-ignore
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    width: "25",
                                    height: "19",
                                    viewBox: "0 0 20 19",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M1.01953 0.696899L18.6972 18.3746",
                                            stroke: "black"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M1.01953 18.3745L18.6972 0.69684",
                                            stroke: "black"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileNav, {
                show: showMobileNav,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Links, {
                    className: "",
                    howItWorksRef: howItWorksRef
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavEdge, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Nav);
// Simplified NavEdge without the howItWorksRef parameter
const NavEdge = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-12.5 h-full shadow-inner bg-white lg:block hidden",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "h-5 bg-[#131D19] w-full"
        })
    });
};
// Updated Links component to handle the howItWorksRef correctly
const Links = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    // Function to handle link clicks
    const handleLinkClick = (item, e)=>{
        // Special handling for "HOW IT WORKS" link
        if (item.title === "HOW IT WORKS ↗") {
            // If not on the homepage, navigate to homepage with #how-it-works anchor
            if (router.pathname !== "/") {
                e.preventDefault();
                router.push("/#how-it-works");
            } else if (props.howItWorksRef && props.howItWorksRef.current) {
                // If on homepage, scroll to the section
                e.preventDefault();
                props.howItWorksRef.current.scrollIntoView({
                    behavior: "smooth"
                });
            }
        } else if (item.title === "MEET TO ASPIRE ↗") {
            e.preventDefault();
            window.open(item.link, "_blank");
        }
    // Other links use their default behavior
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex lg:flex-row flex-col lg:gap-0 gap-3.75", props.className),
        children: linkData.map((item, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                onClick: (e)=>handleLinkClick(item, e),
                href: item.title === "HOW IT WORKS ↗" ? router.pathname !== "/" ? "/#how-it-works" : "#" : item.link,
                className: "w-[150px] inline-block lg:text-center text-xs md:text-1xs font-medium ".concat(item.link.includes(router.pathname) ? "text-green-text" : "text-dark-gray"),
                children: item.title
            }, index);
        })
    });
};
const MobileNav = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_src_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("w-full lg:hidden bg-white duration-500 absolute overflow-hidden top-[65px]", {
            "max-h-[300px]": props.show,
            "max-h-0": !props.show
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "py-10 px-5",
            children: props.children
        })
    });
};


/***/ }),

/***/ 93551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WY": function() { return /* binding */ request; },
  "wh": function() { return /* binding */ useFetcher; },
  "QT": function() { return /* binding */ useRequest; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/lib/client.ts
// import "unfetch/polyfill";
// import axios from 'axios'
const BASE_URL = "https://apidev.myblankspace.com";
// const BASE_URL = "https://api.catlog.shop"
async function formClient(endpoint, method, param, tokenSource) {
    let { formData , customHeaders  } = param, baseUrl = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : BASE_URL;
    const localToken = localStorage === undefined ? null : localStorage.token;
    const sessionToken = sessionStorage === undefined ? null : sessionStorage.token;
    const token = tokenSource === "local" ? localToken : sessionToken;
    const headers = removeUndefinedValues({
        Authorization: token ? "Bearer ".concat(token) : undefined,
        ...customHeaders
    });
    return window.fetch("".concat(baseUrl, "/").concat(endpoint), {
        method,
        body: formData,
        headers
    }).then(async (response)=>{
        const data = response.status === 204 ? {} : await response.json();
        if (response.status === 401 && token) {
            const storage = tokenSource === "local" ? localStorage : sessionStorage;
            storage.removeItem("token");
            storage.removeItem("user");
            location.reload();
        }
        if (response.ok) {
            return data;
        } else {
            return Promise.reject(data);
        }
    });
}
async function client(endpoint, method) {
    let { data , headers: customHeaders , ...customConfig } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tokenSource = arguments.length > 3 ? arguments[3] : void 0, baseUrl = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : BASE_URL;
    const localToken = localStorage === undefined ? null : localStorage.token;
    const sessionToken = sessionStorage === undefined ? null : sessionStorage.token;
    const token = tokenSource === "local" ? localToken : sessionToken;
    const headers = removeUndefinedValues({
        Authorization: token ? "Bearer ".concat(token) : undefined,
        "Content-Type": data ? "application/json" : undefined,
        ...customHeaders
    });
    const config = {
        method,
        body: data ? JSON.stringify(data) : undefined,
        headers,
        ...customConfig
    };
    return window.fetch("".concat(baseUrl, "/").concat(endpoint), config).then(async (response)=>{
        const data = response.status === 204 ? {} : await response.json();
        if (response.status === 401 && token) {
            const storage = tokenSource === "local" ? localStorage : sessionStorage;
            storage.removeItem("token");
            storage.removeItem("user");
            location.reload();
        }
        if (response.ok) {
            return data;
        } else {
            return Promise.reject(data);
        }
    });
}
function uploadClient(data, progressCallback, eventCallback) {
    const token = localStorage.token;
    const { file , endpoint  } = data;
    const formdata = new FormData();
    formdata.append("file", file);
    const ajax = new XMLHttpRequest();
    ajax.upload.addEventListener("progress", function(event) {
        const progress = event.loaded / event.total;
        const percent = Math.round(progress * 100);
        progressCallback(percent);
    }, false);
    ajax.addEventListener("load", (event)=>{
        eventCallback(event.target, null, ajax);
    }, false);
    ajax.addEventListener("error", (event)=>{
        eventCallback(null, event.target, ajax, uploadFun);
    }, false);
    ajax.addEventListener("abort", ()=>eventCallback(null, {
            message: "Upload aborted"
        }, ajax, uploadFun), false);
    function uploadFun() {
        ajax.open("POST", "".concat(BASE_URL, "/").concat(endpoint));
        ajax.setRequestHeader("Authorization", "Bearer ".concat(token));
        ajax.send(formdata);
    }
    uploadFun();
}
function removeUndefinedValues(obj) {
    const result = {};
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null) {
            result[key] = obj[key];
        }
    }
    return result;
}


;// CONCATENATED MODULE: ./src/hooks/useRequest.ts


const NODE_ENV = "production";
const MSG_RETRY_NETWORK = "Please check your network and try again.";
const MSG_SERVER_ERR = "Something went wrong.";
const DEV_ERRORS = (/* unused pure expression or super */ null && ([
    "SyntaxError",
    "TypeError"
]));
class RequestError extends Error {
    constructor(ex, ...args){
        super(...args);
        this.exception = ex;
        this.response = ex.response;
        if (typeof Error.captureStackTrace === "function") {
            Error.captureStackTrace(this, RequestError);
        }
    }
}
function getErrorMessage(e) {
    const { message , name  } = e;
    if (message) {
        if (e instanceof TypeError && message === "Failed to fetch") {
            return MSG_RETRY_NETWORK;
        }
        const hideMessage = DEV_ERRORS.includes(name);
        return hideMessage ? MSG_SERVER_ERR : message;
    } else {
        return MSG_RETRY_NETWORK;
    }
}
function errorHandler(err) {
    const msg = getErrorMessage(err);
    return new RequestError(err, msg);
}
class CustomError extends Error {
    constructor(error){
        super();
        this.message = error.message;
        this.body = {
            ...error
        };
    }
}
// function CustomError(error) {
// 	this.body = {...error};
// 	this.message = error.message;
// }
// CustomError.prototype = Error.prototype;
async function request(endpoint, method) {
    let conf = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tokenSource = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "local", baseUrl = arguments.length > 4 ? arguments[4] : void 0, mode = arguments.length > 5 ? arguments[5] : void 0;
    const config = {
        ...conf
    };
    try {
        const response = mode === "form" ? await formClient(endpoint, method, {
            formData: config.data,
            customHeaders: config.headers
        }, tokenSource, baseUrl) : await client(endpoint, method, {
            ...config
        }, tokenSource, baseUrl);
        const data = response;
        const err = response.status > 299 ? new CustomError(data) : null;
        return [
            data,
            err
        ];
    } catch (err1) {
        if (NODE_ENV !== "production") {
            console.error("request failed on endpoint ".concat(endpoint));
        }
        return [
            null,
            err1
        ];
    }
}
function useRequest(func, def, preventRetries) {
    const [state, setState] = (0,react.useState)({
        isLoading: false,
        error: null
    });
    const [response, setResponse] = (0,react.useState)(def);
    const makeRequest = async function(data) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            params[_key - 1] = arguments[_key];
        }
        if (preventRetries && (!!state.isLoading || !!state.error || !!response)) return [];
        setResponse(def);
        setState({
            isLoading: true,
            error: null
        });
        const [res, err] = await func({
            ...params,
            ...data
        });
        setResponse(res);
        setState({
            isLoading: false,
            error: err
        });
        return [
            res,
            err
        ];
    };
    const clearResponse = ()=>{
        setResponse(def);
        setState({
            ...state,
            error: null
        });
    };
    return {
        ...state,
        response,
        makeRequest,
        clearResponse
    };
}
function useFetcher(func, params, required) {
    const [state, setState] = (0,react.useState)({
        isLoading: false,
        error: null
    });
    const [response, setResponse] = (0,react.useState)(null);
    const deps = params ? [
        ...paramsToArray(params)
    ] : [];
    (0,react.useEffect)(()=>{
        const newParams = {
            ...params
        };
        const available = required === null || required === void 0 ? void 0 : required.map((param)=>newParams[param] !== null && newParams !== undefined);
        if (available === null || available === void 0 ? void 0 : available.includes(false)) return;
        makeRequest();
    }, deps);
    const makeRequest = async ()=>{
        if (params) {
            setState({
                isLoading: true,
                error: null
            });
            const [response, error] = await func(params);
            setResponse(response);
            setState({
                isLoading: false,
                error
            });
            return [
                response,
                error
            ];
        }
    };
    return {
        ...state,
        response,
        makeRequest
    };
}
function paramsToArray(params) {
    const array = [];
    for(let param in params){
        if (typeof params[param] === "object") {
            array.push(JSON.stringify(params[param]));
        } else {
            array.push(params[param]);
        }
    }
    return array;
}


/***/ })

}]);